import { Component, ViewChild, Input, ElementRef } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import {DataSourceGrid} from '../utils/data-source-grid.component';
import {MatPaginator,MatDialog, MatSort} from '@angular/material';
import { modalConfirmationComponent } from '../utils/modal/modal-confirmation.component';
import { Router, ActivatedRoute } from '@angular/router';
import { generalService } from '../services/general.service';
import { Cliente } from '../models/cliente';
import 'rxjs/add/operator/startWith';
import 'rxjs/add/observable/merge';
import 'rxjs/add/operator/map';
import { SaleExportData } from '../models/sale-export-data';
import { PdfExporterService } from '../cliente-sae/service/pdf-exporter.service';
import { DatosGeneralesSAE } from '../datos-generales-SAE';


// ESTO ERA PARA EXPORTAR A EXCEL
//const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
//const EXCEL_EXTENSION = '.xlsx';

import { PagoVentaService } from '../pago-venta/pago-venta.service';
import { CDK_ROW_TEMPLATE } from '@angular/cdk/table';

import * as moment from 'moment';
import 'moment/locale/es';


@Component ({
	selector: 'concentradopagos',
	templateUrl: './concentrado-pagos.component.html',
    styleUrls: ['./concentrado-pagos.component.scss'], 
    providers: [generalService, PdfExporterService]
	})

export class ConcentradoPagosComponent  {
  public datosGeneralesSAE: any;
  dataCobrar: DataSourceGrid | null;
  dataVentas: DataSourceGrid | null;
  dataAprobacion: DataSourceGrid | null;
  displayedColumnsII = ['columna','columnaI', 'columnaII', 'columnaIII', 'columnaIV', 'columnaV', 'columnaVI'];
  public userData: any = JSON.parse(sessionStorage.getItem('user'));
  @Input() cliente: Cliente;
  public cliente_id: string;
  public historialAprobacion:Array<any>;
  public detallesAprobacion:Array<any>;
  public stringAprobacion: string;
  public stringDetalles: string;
  public aprobacionPagos: boolean = false;
  public matOptions: any;
  public selectedPayment: any;
  public showDatepicker: number;
  public filtrosAprobacion: any;
  public filtrosAprobacionDetalle: any;
  public pagoFiltro: any;
  private cuentasAPagar = [];
  public arrayPagos = [];
  public changePayment: boolean;
  public disablePayment: boolean = false;

  locale: {
    language: 'es',
    format: 'DD-MM-YYYY', 
    separator: ' - ',
    applyLabel: 'Ok',
    customRangeLabel: 'Rango Personalizado',
    firstDay: 1   };
  ranges: any = {
    'Hoy': [moment(), moment()],
    'Semana actual': [moment().startOf('week'), moment().endOf('week')],
    'Mes actual': [moment().startOf('month'), moment().endOf('month')],
    'Ultimos 2 meses': [moment().subtract(2, 'month').startOf('month'), moment(), moment()] };

  public dateRange: any = {
    startDate: moment().startOf('month'),
    endDate: moment(), 
  };

constructor( private formBuilder: FormBuilder, private router: Router, 
             public dialog: MatDialog, /*private pdfExporterService: PdfExporterService, */
             private route: ActivatedRoute, private _generalService: generalService,
             private pagoVentaService: PagoVentaService ) {
  //Se manda un 0, para que la consulta traiga todos los clientes de la commpañia
  this.cliente_id = '0';//this.route.snapshot.paramMap.get('id');
  this.cliente = new Cliente();
  this.historialAprobacion = new Array();
  this.datosGeneralesSAE = DatosGeneralesSAE;

  //El SPINNER SE ACTIVA AQUI, CUANDO SE COMIENZA A CARGAR LA PANTALLA
  this.datosGeneralesSAE.showSpinnerLoading = true;
  moment.locale('es');
}

  @ViewChild(MatSort) sortII: MatSort;
  @ViewChild(MatPaginator) paginatorII: MatPaginator;

  //ESTAS ERAN LAS VISTAS DEL PDF DE LAS VENTAS
  //@ViewChild('pdfContainer')
  //private pdfContainer: ElementRef;

  //@ViewChild('pdfContainerNoPrice')
  //private pdfContainerNoPrice: ElementRef;

	ngOnInit() {    
    this.getCliente(this.cliente_id);
    //this.isAdmin();
    this.consultarAprobacion(0);
    this.consultarAprobacionDetalles();
    this.buildMatOptionsList();
  }

  ngModelChange(valor){
    if(this.aprobacionPagos === true){
      this.consultarAprobacion(this.pagoFiltro); }
  }

// ESTE ERA EL IF DEL PERMISO DEL ADMIN
/*
  isAdmin(){
    if (this.userData.ADMIN == 1) {
      this.admin = true;  }
    else {
      this.noAdmin = true;  }
  } */
    
  getCliente(id:any){
    this._generalService.metodoCall(`cliente/consultarCliente/${id}`).subscribe(
      result => {
        let res = JSON.parse(result);
        this.cliente = res[0];

        if (res[0].DEBT === 0) {
          this.disablePayment = true; }
      },
      error => {
        console.log(<any>error);  }
    );
  }

  consultarAprobacion(opcion){
    this.pagoFiltro = opcion;
    let tipo = 'agregar';
    this.stringAprobacion = "HistorialPagos/consultarAprobacionPagos/";
    this.filtrosAprobacion = {
      idCliente: this.cliente_id,
      rangoInicio: this.dateRange.startDate.format('YYYY-MM-DD'),
      rangoFinal: this.dateRange.endDate.format('YYYY-MM-DD'),
      filtro: opcion  ,
  	  idUsuario: this.userData.USER_ID};

    if (this.pagoFiltro == 0) {
      this.changePayment = true;  }
    else {
      this.changePayment = false; }

    this._generalService.metodoCallParamsPutPost(tipo, this.filtrosAprobacion, this.stringAprobacion)
      .subscribe(result => {
        this.historialAprobacion = JSON.parse(result);
        this.dataAprobacion = new DataSourceGrid(this.historialAprobacion, this.paginatorII, this.sortII);
        if(this.historialAprobacion.length <= 0)
          { $(".mat-row").remove(".mat-row"); }
        },
      error => {  console.log(<any>error);  }
    ); 
  }


  //Método Original antes del Concentrado de Clientes
  /*consultarAprobacionDetalles(){

    this.stringDetalles = "HistorialPagos/consultarAprobacionDetalles/" + this.cliente_id;

    this._generalService.metodoCall(this.stringDetalles).subscribe(
      result => { 
      	this.detallesAprobacion = JSON.parse(result);

      	// Y SE DESACTIVA AQUI CUANDO YA SE CARGARON LOS DATOS DETALLE 
      	this.datosGeneralesSAE.showSpinnerLoading = false;  },
      error => {  console.log(<any>error);  }
    );
  }*/

   //Ejemplo de método ya con el concentrado de Clientes, función POST enviando un objeto
   /*consultarAprobacionDetalles2(){

    let tipo = 'agregar';
    this.stringDetalles = "HistorialPagos/consultarAprobacionDetalles/";
    this.filtrosAprobacion = {
      idCliente: this.cliente_id,
      rangoInicio: this.dateRange.startDate.format('YYYY-MM-DD'),
      rangoFinal: this.dateRange.endDate.format('YYYY-MM-DD'),
      filtro: 0  ,
  	  idUsuario: this.userData.USER_ID};

    this._generalService.metodoCallParamsPutPost(tipo, this.filtrosAprobacion, this.stringDetalles)
      .subscribe(result => {
        this.detallesAprobacion = JSON.parse(result);
        	// Y SE DESACTIVA AQUI CUANDO YA SE CARGARON LOS DATOS DETALLE 
      	this.datosGeneralesSAE.showSpinnerLoading = false;
        },
      error => {  console.log(<any>error);  }
    ); 
  }*/

    //Método final del concentrado de Pagos, envía 2 parámetros con un GET
    consultarAprobacionDetalles() {
    let webService = 'HistorialPagos/consultarAprobacionDetalles?idCliente=' + this.cliente_id + '&&idUsuario=' + this.userData.USER_ID;
    this._generalService
      .metodoCall(webService, true)
      .subscribe(result => {
      	 this.detallesAprobacion = JSON.parse(result);
        	// Y SE DESACTIVA AQUI CUANDO YA SE CARGARON LOS DATOS DETALLE 
      	this.datosGeneralesSAE.showSpinnerLoading = false;
        },
      error => {  console.log(<any>error);  }
      );
    }

  back()  {
      this.router.navigate(['../../clientes-sae'],{ relativeTo: this.route });    
  }


// ESTA FUNCIÓN DABA EL PROCESO PARA CAMBIAR ENTRE PESTAÑAS DE LA PANTALLA, YA NO SE USA
/*
  showTab(cobrar: boolean, venta:boolean, pagos: boolean) {
    this.dateRange.startDate = moment().startOf('month');
    this.dateRange.endDate = moment();
    if (cobrar === true){
        this.cuentasCobrar = true;
        this.ventas = false;
        this.aprobacionPagos = false;
        if(this.showDatepicker === 1) {
          document.getElementById("idDatePicker").style.visibility = "visible";
        } else {
          document.getElementById("idDatePicker").style.visibility = "hidden";
        }
    }
    if (pagos === true){
       // this.cuentasCobrar = false;
        //this.ventas = false;
        this.aprobacionPagos = true;
        document.getElementById("idDatePicker").style.visibility = "visible";
        this.consultarAprobacion(0);
        this.consultarAprobacionDetalles();
    }
  } */

  buildMatOptionsList() {
    this.matOptions = new Object();
    this.matOptions.payments = [
      {code: 0 , meaning: 'Sin aprobar'},
      {code: 1 , meaning: 'Aprobadas'},
      {code: 2 , meaning: 'Rechazadas'},
    ];
    this.selectedPayment = this.matOptions.payments[1].code;
  }

  // -------------- FUNCIONES DE ACCIONES ---------------
  editarArrayPagos(pagoAgregado: boolean, pagoAgregar) {
    if(pagoAgregado){
      this.arrayPagos.push(pagoAgregar);  }
    else {
      this.arrayPagos.forEach( 
        (item, index) => {
          if(item === pagoAgregar) this.arrayPagos.splice(index,1); });
    }
  }

  aprobarPagos(isApproved){
    let tipo = 'agregar';

    if(this.arrayPagos.length >= 1){
      //for (let i = 0; i < this.arrayPagos.length; i++) {
        let datosPago ={
          //idPago: this.arrayPagos[i],
          aprobacion: isApproved,
          idUsuario: this.userData.USER_ID,
          json: JSON.stringify(this.arrayPagos)
        };
        
        let link = 'HistorialPagos/actualizarPagos/';
        this._generalService.metodoCallParamsPutPost(tipo, datosPago, link)
          .subscribe( (result) => {
            const arrayResult = JSON.parse(result);
            for (let i = 0; i < arrayResult.length; i++) {
              if (arrayResult[i] != '') {
                this._generalService.toastCall(arrayResult[i]); } 
              else {
                this._generalService.toastCall("Pago agregado exitósamente"); this.consultarAprobacion(0);}
            }
          },
          (error) => {
            const errorMsj =  error as any;
            console.log(errorMsj); 
          }); 
        console.log(datosPago);  
      //}
    }
    else{
      this._generalService.toastCall("No se ha seleccionado un pago para realizar esta acción");
    }
  }

  crearTicketPago(idPayment: any){
  this.datosGeneralesSAE.showSpinnerLoading = true;
  // Se consulta la información y configuración del ticket en base al pago y sucursal
  this._generalService.requestGet("pago/crearTicketPago?idOrganization=" + this.userData.ORGANIZATION_ID + "&idPayment=" + idPayment).subscribe(
      (result) => {

          // El primer paso para imprimir el ticket es transformar la base64 a un arreglo de bytes con el cual se obtendrá un 
          // objeto blob
          const b64toBlob = (b64Data, contentType='', sliceSize=512) => {
              const byteCharacters = atob(b64Data);
              const byteArrays = [];
              for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
                  const slice = byteCharacters.slice(offset, offset + sliceSize);
                  const byteNumbers = new Array(slice.length);
                  for (let i = 0; i < slice.length; i++) {
                      byteNumbers[i] = slice.charCodeAt(i);
                  }
                  const byteArray = new Uint8Array(byteNumbers);
                  byteArrays.push(byteArray);
              }
              const blob = new Blob(byteArrays, {type: contentType});
              return blob;
          }
          const blob = b64toBlob(result, "application/pdf");

          // Se crea una url valida con el objeto blob
          const blobUrl = URL.createObjectURL(blob);

          // Se elimina el iframe del ticket si ya había sido creado uno
          if (document.getElementById("iframeTicketII") != null){
              $("#iframeTicketII").remove();
          }

          // Se crea un iframe para el ticket y se le pone como src el url creado apartir del blob
          var iframe: any = document.createElement('iframe');
          iframe.id = "iframeTicketII";
          iframe.style.display = 'none';
          iframe.src = blobUrl;
          document.body.appendChild(iframe);

          // Se pone en un timeout en lo que se espera a que se agrege al body del document y se pueda imprimir
          setTimeout(()=>{    
              // Se imprime el ticket
              iframe.focus();
              iframe.contentWindow.print();

              this.datosGeneralesSAE.showSpinnerLoading = false;
         }, 100);

      },
      (error) => {
          const errorMsj =  error as any;
          console.error(errorMsj);
      }
  );

  }
}




// WEBPACK FOOTER //
// ./src/app/pagos/concentrado-pagos.component.ts